import { render, staticRenderFns } from "./DriversTable.vue?vue&type=template&id=f60972b0&"
import script from "./DriversTable.vue?vue&type=script&lang=js&"
export * from "./DriversTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports